import {
  Column,
  ColumnDefTemplate,
  Header,
  HeaderContext,
  Table,
} from "@tanstack/react-table"
import { useState } from "react"

export const isTextCell = <T>(
  headerDef: ColumnDefTemplate<HeaderContext<T, unknown>>
): boolean => typeof headerDef === "function"

export const extractTextCellValue = <T>(
  headerDef: ColumnDefTemplate<HeaderContext<T, unknown>>,
  column: Column<T, unknown>
): string => {
  if (typeof headerDef === "function") {
    const headerElement = headerDef({
      column,
      header: undefined as unknown as Header<T, unknown>,
      table: undefined as unknown as Table<T>,
    })
    return headerElement.props.value
  }
  return headerDef
}

export const getColumnLabel = <T>(column: Column<T, unknown>): string => {
  const headerDef = column.columnDef.header
  if (!headerDef) {
    return column.id
  }
  if (typeof headerDef === "string") {
    return headerDef
  }
  if (isTextCell(headerDef)) {
    return extractTextCellValue(headerDef, column)
  }
  return column.id
}

export const useControlledState = (
  controlledValue?: boolean,
  controlledSetter?: React.Dispatch<React.SetStateAction<boolean>>
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [internalValue, setInternalValue] = useState(false)

  const isControlled =
    controlledValue !== undefined && controlledSetter !== undefined

  const value = isControlled ? controlledValue : internalValue
  const setValue = isControlled ? controlledSetter : setInternalValue

  return [value, setValue]
}
